import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import take from 'lodash/take';
import isEqual from 'lodash/isEqual';
import { useTranslation } from 'react-i18next';

import { Button } from 'formlabs-web-components/Link';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Header } from 'formlabs-web-components/Type';

import ProductListItem from './ProductListItem';
import BundleProduct from './BundleProduct';
import ProductListPager from './ProductListPager';

import './ProductList.module.css';

const specialBundles = ['RS-F2-PKG-CR', 'PKG-F2-RWS']; // HACK These are bundle items, but should be displayed as normal product

const ProductList = ({
  baseUrl,
  category,
  limit,
  hideHeader,
  highlightBundles,
  products,
  wideItems,
  hasMore = false
}) => {
  const [t] = useTranslation();
  const [displayProducts, setProducts] = useState(
    products ? (limit > 0 ? take(products, limit) : products) : null
  );

  if (!products) {
    return null;
  }

  const showMore =
    hasMore || (products && products.length > displayProducts.length);

  let header = null;
  if (!hideHeader && category) {
    header = (
      <div styleName={classnames('header')}>
        <div>
          <Header
            level={1}
            displayAs={3}
            weight="600"
            styles={{ marginBottom: 0 }}
          >
            {category.name}
          </Header>
          {category.attributes && category.attributes.description && (
            <div
              styleName="description"
              dangerouslySetInnerHTML={{
                __html: category.attributes.description
              }}
            />
          )}
        </div>
        {showMore ? (
          <ProductListPager
            styleName="pager"
            categoryId={category.id}
            resultCallback={result => {
              if (!isEqual(displayProducts, result.items)) {
                setProducts(result.items);
              }
            }}
          />
        ) : null}
      </div>
    );
  }

  return (
    <div styleName="container">
      {header}
      <ul styleName={classnames('products', { hideBorder: hideHeader })}>
        {displayProducts.map(product => {
          const isBundle =
            product.type_id === 'bundle' &&
            specialBundles.indexOf(product.sku) === -1;

          return (
            <li
              styleName={classnames('product', {
                bundle: isBundle,
                wide: wideItems || product.displayWide
              })}
              key={product.sku}
            >
              {isBundle && highlightBundles ? (
                <BundleProduct
                  baseUrl={baseUrl}
                  product={product}
                  manualEntry={Boolean(product.manualEntry)}
                />
              ) : (
                <ProductListItem baseUrl={baseUrl} product={product} />
              )}
            </li>
          );
        })}
      </ul>
      {showMore && category && category.url ? (
        <div styleName="more">
          <Button color="dark" to={`${baseUrl}${category.url}/`}>
            {category && category.name
              ? t('See all {{categoryName}}', { categoryName: category.name })
              : t('See all')}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

ProductList.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  limit: PropTypes.number
};

ProductList.defaultProps = {
  highlightBundles: true,
  limit: 0
};

export default DisplayComponent(ProductList);
